<template>
  <div class="row">
    <div class="col-12" style="text-align: right">
      <q-btn-group outline>
        <c-btn
          v-if="editable"
          :url="saveUrl"
          :isSubmit="isSave"
          :param="ghsResult"
          mappingType="PUT"
          label="저장"
          icon="save"
          @beforeAction="saveInfo"
          @btnCallback="saveCallback"
        />
      </q-btn-group>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <c-table
        ref="table"
        title="유해위험성"
        :merge="grid.merge"
        :columns="grid.columns"
        :data="ghsResult.classes"
        :gridHeight="gridHeight"
        @innerBtnClicked="innerBtnClicked"
      >
        <template slot="table-button">
          <q-btn-group outline>
            <q-icon
              name="help_outline"
              class="q-mr-sm cursor-pointer"
              size="sm"
            >
              <q-popup-proxy>
                <c-table
                  title="유해위험성 구분 범례"
                  :columns="gridClass.columns"
                  :data="gridClass.data"
                  :gridHeight="gridClass.height"
                  hideBottom
                >
                </c-table>
              </q-popup-proxy>
            </q-icon>
            <c-btn
              v-if="editable"
              label="분류 추가"
              icon="add"
              @btnClicked="addHarmfulRiskClass"
            />
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'harmfulRiskResultCd'">
            <c-select
              stype="tableselect"
              :editable="editable"
              :isSelect="true"
              :codeGroupCd="setResultGroupCd(props)"
              type="edit"
              itemText="codeName"
              itemValue="code"
              v-model="props.row[col.name]"
              @datachange="(val) => datachange(props)"
            />
          </template>
          <template v-else-if="col.name === 'delete'">
            <q-icon
              name="delete"
              color="red-7"
              size="xs"
              class="cursor-pointer"
              @click="deleteHarmRiskClass(props.row)"
            />
          </template>
        </template>
      </c-table>
      <!-- <c-card title="유해위험성" class="cardClassDetailForm" topClass="topcolor-orange">
        <template slot="card-detail">
          <div class="col-12 ghsinfodetail">
            <c-textarea
              :editable="editable"
              :rows="2"
              name="classficationResult"
              v-model="ghsResult.classficationResult">
            </c-textarea>
          </div>
        </template>
      </c-card> -->
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <q-form ref="editForm">
        <c-card
          title="신호어"
          class="cardClassDetailForm"
          topClass="topcolor-orange"
        >
          <template slot="card-detail">
            <div class="col-12 ghsinfodetail">
              <c-textarea
                :editable="editable"
                :rows="2"
                name="sign"
                v-model="ghsResult.sign"
              >
              </c-textarea>
            </div>
          </template>
        </c-card>
        <c-card
          title="그림문자"
          class="cardClassDetailForm picCard"
          topClass="topcolor-orange"
        >
          <template slot="card-detail">
            <q-intersection
              v-for="(item, index) in ghsResult.pics"
              :key="index"
              class="example-item"
              style="display: inline-table"
            >
              <template v-if="item.pic !== '해당없음'">
                <img
                  :src="require('@/assets/images/' + item.pic + '.gif')"
                  :style="{ width: '70px' }"
                />
                <q-checkbox
                  v-model="item.chk"
                  color="red"
                  size="xs"
                  true-value="Y"
                  false-value="N"
                />
              </template>
            </q-intersection>
          </template>
        </c-card>
        <c-card
          title="유해·위험문구"
          class="cardClassDetailForm"
          topClass="topcolor-orange"
        >
          <template slot="card-detail">
            <div class="col-12 ghsinfodetail">
              <c-textarea
                :editable="editable"
                :rows="2"
                name="sign"
                v-model="ghsResult.hcodeResult"
              >
              </c-textarea>
            </div>
          </template>
        </c-card>
        <c-card
          title="예방조치문구"
          class="cardClassDetailForm"
          topClass="topcolor-orange"
        >
          <template slot="card-detail">
            <div class="col-12 ghsinfodetail">
              <c-textarea
                :editable="editable"
                :rows="2"
                name="sign"
                v-model="ghsResult.pcodeResult"
              >
              </c-textarea>
            </div>
          </template>
        </c-card>
      </q-form>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "chem-ghs-2",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: "",
        subtabName: "",
        plantCd: null,
      }),
    },
    chemData: {
      type: Object,
      default: () => ({
        plantCd: null, // 사업장코드
        mdmChemMaterialId: "", // 화학자재 일련번호
        materialCd: "", // 자재코드
        mdmChemReviewId: "", // 사전검토 일련번호
        deliveryVendorCd: "", // 공급업체 코드
        // mfgVendorCd: '',  // (사용안함) 제조업체 코드
        propertiesStateCd: null, // 성상-공통코드
        fugacity: "", // 비산성(고체)
        boilPoint: "", // 끊는점(액체,기체)
        meltingPoint: "", // 녹는점
        moleWeight: "", // 분자량
        usageCd: null, // 용도-회사별 공통코드
        usageEtc: "", // 용도 기타
        mixFlag: "", // 물질구성(단일 N/혼합 Y)
        casNo: "", // CAS No.
        // hsNo: '',  // (사용안함) HS번호
        // specificGravity: '',  // (사용안함) 비중
        // serialNo: '',  // (사용안함) 고유번호(유독물번호or고시번호)
        // keNo: '',  // (사용안함) KE 번호
        // storagePlace: '',  // (사용안함) 보관장소
        productCategoryCd: null, // 제품구분
        keepFacilityFlag: "N", // 보관시설 유무
        maxKeepAmount: "", // 최대보관량
        storageFacilityFlag: "N", // 저장시설 유무
        maxStorageAmount: "", // 최대저장량
        manufacturingFacilitiesFlag: "N", // 제조 사용시설 여부
        nanoManufacturingFlag: "N", // 나노물질 제조 여부
        nanoIncomeFlag: "N", // 나노물질 수입 여부
        nanoNoneApplicableFlag: "N", // 나노물질 해당없음 여부
        nanoUnknownFlag: "N", // 나노물질 모름 여부
        inputDissolutionTank: "", //
        productManufClassCd: null, // 제품제조구분 코드
        chemIngredientsCd: "", // 구성성분 작성근거
        useFlag: "Y", // 사용여부
        licensingFlag: "N", // 인허가대상 물질 여부 Y/N
        dangerFlag: "N", // 위험물 여부Y/N
        psmFlag: "N", // PSM 대상 여부
        makeFlag: "N", // 제품분류(제조)
        impFlag: "N", // 제품분류(수입)
        buyFlag: "N", // 제품분류(구매)
        usingFlag: "N", // 제품분류(사용)
        expFlag: "N", // 제품분류(수출)
        salesFlag: "N", // 제품분류(판매)
        toxicPoisonFlag: "N", // 유해화학물질포함여부(유독물질)
        toxicPermitFlag: "N", // 유해화학물질포함여부(허가물질)
        toxicLimitFlag: "N", // 유해화학물질포함여부(제한물질)
        toxicProhibitFlag: "N", // 유해화학물질포함여부(금지물질)
        remarks: "", // 비고
        regUserId: "", // 등록자 ID
        chgUserId: "", // 수정자 ID
        // specialCtype: '',  // (사용안함) 발암성 C-위험성평가용
        // specialRtype: '',  // (사용안함) 생식독성 R-위험성평가용
        // specialMtype: '',  // (사용안함) 생식세표변이원성 M-위험성평가용
        // rcode: '',  // (사용안함) 위험문구(R-phrase)-위험성평가용
        // hcode: '',  // (사용안함) 유해위험문구(H-code)-위험성평가용
        // cmrFlag: '',  // (사용안함) CMR물질여부-위험성평가용
        // boilingPoint: '',  // (사용안함) 끓는점-위험성평가용
        // hrCodeGrade: '',  // (사용안함) 위험문구/유해위험문구 등급-위험성평가용
        // maleficenceForm: '',  // (사용안함) 유해성 발생형태-위험성평가용
        // maleficenceValue: '',  // (사용안함) 유해성 측정값-위험성평가용
        // maleficenceGrade: '',  // (사용안함) 비산성 등급-위험성평가용
        // maleficenceType: '',  // (사용안함) 비산/휘발성 구분-위험성평가용
        // dayVolume: '',  // (사용안함) 하루취급량
        // dayVolumeUnit: '',  // (사용안함) 하루취급량 단위
        // ghsFlag: '',  // (사용안함) GHS 분류코드
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      harmRiskItems: [],
      ghsResult: {
        // classficationResult: '',
        classes: [],
        deleteClasses: [],
        pics: [],
        sign: "",
        pcodeResult: "",
        hcodeResult: "",
        regUserId: "",
        chgUserId: "",
      },
      grid: {
        merge: [{ index: 0, colName: "harmfulRiskClassCd" }],
        columns: [
          {
            name: "harmfulRiskClassName",
            field: "harmfulRiskClassName",
            label: "분류",
            align: "center",
            style: "width:150px",
            sortable: true,
            innerBtn: true,
            btns: [
              {
                label: "",
                icon: "add",
                color: "light-blue",
                value: "1",
                tooltip: "적용 구분 추가",
              },
            ],
          },
          {
            name: "harmfulRiskResultCd",
            field: "harmfulRiskResultCd",
            label: "적용 구분",
            align: "center",
            style: "width:100px",
            sortable: true,
            required: true,
            type: "custom",
          },
          {
            name: "harmfulRiskDetails",
            field: "harmfulRiskDetails",
            label: "구분 부가설명",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "text",
          },
          {
            name: "delete",
            field: "delete",
            label: "삭제",
            align: "center",
            style: "width:50px",
            sortable: true,
            type: "custom",
          },
        ],
      },
      gridClass: {
        columns: [
          {
            fix: true,
            name: "harmfulRiskClassName",
            field: "harmfulRiskClassName",
            label: "유해위험성구분",
            align: "center",
            style: "width:130px",
            sortable: true,
          },
          {
            name: "gubun1",
            field: "gubun1",
            label: "구분1",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun1a",
            field: "gubun1a",
            label: "구분1A",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun1b",
            field: "gubun1b",
            label: "구분1B",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun1c",
            field: "gubun1c",
            label: "구분1C",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun2",
            field: "gubun2",
            label: "구분2",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun2a",
            field: "gubun2a",
            label: "구분2A",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun2b",
            field: "gubun2b",
            label: "구분2B",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun3",
            field: "gubun3",
            label: "구분",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun4",
            field: "gubun4",
            label: "구분",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun5",
            field: "gubun5",
            label: "구분",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
        ],
        data: [],
        height: "500px",
      },
      editable: true,
      isSave: false,
      listUrl: "",
      listLegendUrl: "",
      saveUrl: "",
      deleteClassUrl: "",
      popupOptions: {
        isFull: false,
        width: "40%",
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    gridHeight() {
      let height =
        this.contentHeight && !Number.isNaN(Number(this.contentHeight))
          ? Number(this.contentHeight) - 120
          : 200;
      if (height < 200) height = 200;
      return height + "px";
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.ghs.mix.list;
      this.listLegendUrl = selectConfig.mdm.mam.chem.harmfulLegendList.url;
      this.saveUrl = transactionConfig.mdm.ghs.mix.save;
      this.deleteClassUrl = transactionConfig.mdm.ghs.class.delete;
      // code setting
      // list setting
      this.getLegend();
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = {
        mdmChemMaterialId: this.popupParam.mdmChemMaterialId,
      };
      this.$http.request((_result) => {
        this.$_.extend(this.ghsResult, _result.data);
      });
    },
    getLegend() {
      this.$http.url = this.listLegendUrl;
      this.$http.type = "GET";
      this.$http.request((_result) => {
        this.gridClass.data = _result.data;
      });
    },
    innerBtnClicked(col, props) {
      this.ghsResult.classes.splice(props.rowIndex, 0, {
        mdmChemMaterialId: this.popupParam.mdmChemMaterialId, // 화학자재 일련번호
        harmfulRiskClassCd: props.row.harmfulRiskClassCd, // 유해위험성 구분 코드
        harmfulRiskClassName: props.row.harmfulRiskClassName, // 유해위험성 구분 코드
        harmfulRiskResultCdSave: null, // 유해위험성 결과 코드
        harmfulRiskResultCd: null, // 유해위험성 결과 코드
        harmfulRiskDetails: "", // 유해위험성 상세 설명
        regUserId: this.$store.getters.user.userId, // 등록자 ID
        editFlag: "C",
      });
    },
    addHarmfulRiskClass() {
      this.popupOptions.title = "분류 검색";
      this.popupOptions.param = {
        type: "multiple",
      };
      this.popupOptions.target = () =>
        import(`${"./ghsHarmfulRiskClassPop.vue"}`);
      this.popupOptions.width = "40%";
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeHarmfulRiskClassPopup;
    },
    closeHarmfulRiskClassPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, (item) => {
          if (
            this.$_.findIndex(this.ghsResult.classes, {
              harmfulRiskClassCd: item.code,
            }) === -1
          ) {
            this.ghsResult.classes.push({
              mdmChemMaterialId: this.popupParam.mdmChemMaterialId, // 화학자재 일련번호
              harmfulRiskClassCd: item.code, // 유해위험성 구분 코드
              harmfulRiskClassName: item.codeName, // 유해위험성 구분 코드
              harmfulRiskResultCd: null, // 유해위험성 결과 코드
              harmfulRiskDetails: "", // 유해위험성 상세 설명
              regUserId: this.$store.getters.user.userId, // 등록자 ID
              editFlag: "C",
            });
          }
        });
      }
    },
    deleteHarmRiskClass(row) {
      window.getApp.$emit("CONFIRM", {
        title: "확인",
        message: "삭제하시겠습니까?",
        // TODO : 필요시 추가하세요.
        type: "info", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          if (row.editFlag === "C") {
            this.ghsResult.classes = this.$_.reject(
              this.ghsResult.classes,
              row,
            );
            return;
          }
          this.$http.url = this.$format(
            this.deleteClassUrl,
            this.popupParam.mdmChemMaterialId,
            row.harmfulRiskClassCd,
            row.harmfulRiskResultCdSave,
          );
          this.$http.type = "DELETE";
          this.$http.request(() => {
            this.ghsResult.classes = this.$_.reject(
              this.ghsResult.classes,
              row,
            );
            window.getApp.$emit("APP_REQUEST_SUCCESS");
          });
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
    setResultGroupCd(props) {
      let codeGroupCd = "";
      switch (props.row["harmfulRiskClassCd"]) {
        case "HRC0000001": // 급성독성(경구)
        case "HRC0000002": // 급성독성(경피)
        case "HRC0000003": // 급성독성(흡입)
          codeGroupCd = "ACUTE_TOXICITY_CD";
          break;
        case "HRC0000004": // 피부 부식성
        case "HRC0000005": // 피부 자극성
          codeGroupCd = "SKIN_CORROSION_IRRITATION_CD";
          break;
        case "HRC0000006": // 심한 눈 손상성 또는 자극성
          codeGroupCd = "SERIOUS_EYE_DAMAGE_IRRITATION_CD";
          break;
        case "HRC0000007": // 호흡기 과민성
          codeGroupCd = "RESPIRATORY_SENSITIZATION_CD";
          break;
        case "HRC0000008": // 피부 과민성
          codeGroupCd = "SKIN_SENSITIZATION_CD";
          break;
        case "HRC0000009": // 발암성
          codeGroupCd = "CARCINOGENICITY_CD";
          break;
        case "HRC0000010": // 생식세포 변이원성
          codeGroupCd = "GERM_CELL_MUTAGENICITY_CD";
          break;
        case "HRC0000011": // 생식독성
          codeGroupCd = "REPRODUCTIVE_TOXICITY_CD";
          break;
        case "HRC0000012": // 특정표적장기 독성(1회 노출)
        case "HRC0000022": // 산화성 고체
          codeGroupCd = "SPEC_TARGET_ORGAN_TOXICITY_SINGLE_EXPOSURE_CD";
          break;
        case "HRC0000013": // 특정표적장기 독성(반복 노출)
          codeGroupCd = "SPEC_TARGET_ORGAN_TOXICITY_REPEATED_EXPOSURE_CD";
          break;
        case "HRC0000014": // 흡인유해성
          codeGroupCd = "ASPIRATION_HAZARD_CD";
          break;
        case "HRC0000015": // 금속부식성 물질 HZ15C00001
          codeGroupCd = "HAZARD_Z15_CD";
          break;
        case "HRC0000016": // 인화성 가스 HZ16C00001
          codeGroupCd = "HAZARD_Z16_CD";
          break;
        case "HRC0000017": // 인화성 액체 HZ17C00001
          codeGroupCd = "HAZARD_Z17_CD";
          break;
        case "HRC0000018": // 고압가스 HZ18C00001
          codeGroupCd = "HAZARD_Z18_CD";
          break;
        case "HRC0000019": // 수생환경 유해성(급성) HZ19C00001
          codeGroupCd = "HAZARD_Z19_CD";
          break;
        case "HRC0000020": // 수생환경 유해성(만성) HZ20C00001
          codeGroupCd = "HAZARD_Z20_CD";
          break;
        case "HRC0000021": // 자기발열성 물질 및 혼합물 HZ21C00001
          codeGroupCd = "HAZARD_Z21_CD";
          break;
        default:
          codeGroupCd = "";
          break;
      }
      return codeGroupCd;
    },
    datachange(props) {
      /**
       * 적용 구분값이 변경될 시 해당 값은 삭제 처리
       * 변경된 값은 신규등록으로 처리
       */
      if (props.row["editFlag"] !== "C") {
        if (!this.ghsResult.deleteClasses) this.ghsResult.deleteClasses = [];
        if (
          this.$_.findIndex(this.ghsResult.deleteClasses, {
            harmfulRiskClassCd: props.row.harmfulRiskClassCd,
            harmfulRiskResultCd: props.row.harmfulRiskResultCdSave,
          }) === -1
        ) {
          let deleteItem = this.$_.clone(props.row);
          deleteItem.harmfulRiskResultCd = deleteItem.harmfulRiskResultCdSave;
          this.ghsResult.deleteClasses.push(deleteItem);
        }
        props.row["harmfulRiskResultCdSave"] = props.row.harmfulRiskResultCd;
        props.row["editFlag"] = "C";
        props.row["regUserId"] = this.$store.getters.user.userId;
      }
    },
    saveInfo() {
      // 유해/위해성 중 동일한 정보가 들어있는지 검증
      let check =
        this.ghsResult.classes && this.ghsResult.classes.length > 0
          ? this.$comm.validTable(this.grid.columns, this.ghsResult.classes)
          : true;
      this.$refs["editForm"].validate().then((_result) => {
        if (_result && check) {
          let isValid = true;
          let uniqClasses = this.$_.uniq(
            this.$_.map(this.ghsResult.classes, "harmfulRiskClassCd"),
          );
          this.$_.forEach(uniqClasses, (uniqClass) => {
            let filterData = this.$_.filter(this.ghsResult.classes, {
              harmfulRiskClassCd: uniqClass,
            });
            if (
              filterData.length > 1 &&
              this.$_.findIndex(filterData, (filterItem) => {
                return (
                  this.$_.filter(filterData, {
                    harmfulRiskResultCd: filterItem.harmfulRiskResultCd,
                  }).length > 1
                );
              }) > -1
            ) {
              isValid = false;
              return false;
            }
          });
          if (!isValid) {
            window.getApp.$emit("ALERT", {
              title: "안내",
              message:
                "[유해위해성] 분류, 적용 구분값이 동일한 데이터가 존재합니다.\n다시 입력하시기 바랍니다.",
              type: "warning", // success / info / warning / error
            });
            return;
          }
          window.getApp.$emit("CONFIRM", {
            title: "확인",
            message: "저장하시겠습니까?",
            type: "info", // success / info / warning / error
            confirmCallback: () => {
              this.ghsResult.regUserId = this.$store.getters.user.userId;
              this.ghsResult.chgUserId = this.$store.getters.user.userId;
              this.isSave = !this.isSave;
            },
            cancelCallback: () => {},
          });
        }
      });
    },
    saveCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.getList();
    },
  },
};
</script>

<style lang="sass">
.ghsinfodetail
  padding-bottom:10px !important
  margin-top:-20px
.picCard
  .customCardbody
    padding: 10px !important
    margin: 0 !important
</style>
